import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { TreeItem, TreeView } from '@material-ui/lab';
import { theme } from '../theme';

const useStyles = makeStyles({
    logo: {
        fontSize: 36,
    },
    root: {
        maxWidth: 240,
        padding: '12px 0',
        flexGrow: 1,
        '& .MuiTreeItem-label': {
            fontSize: 24,
            '&:hover': {
                backgroundColor: theme.palette.secondary.dark,
                borderRadius: '0 20px 20px 0',
            }
        },
        '& .Mui-selected': {
            '& .MuiTreeItem-content':{
                backgroundColor: '#ffdbdb !important',
                borderRadius: '0 20px 20px 0',
                '& .MuiTreeItem-label': {
                    backgroundColor: 'transparent',
                    '&:hover': {
                        backgroundColor: 'transparent',
                        borderRadius: '0 20px 20px 0',
                    }
                }
            }
        }
    },
});

export default function LeftMenu(props) {
    
    const classes = useStyles();

    return (
        <div className='w-100'>
            <Typography className={`text-left px-4 pt-3 ${classes.logo}`}>如意花園</Typography>
            <TreeView 
                className={classes.root}
                defaultCollapseIcon={null}
                defaultExpandIcon={null}
                defaultSelected='1'
            >
                <TreeItem nodeId="1" label="花園介紹" className={classes.treeItem}></TreeItem>
                {/* <TreeItem nodeId="2" label="花園產品" className={classes.treeItem}></TreeItem> */}
            </TreeView>
        </div>
    )
}